"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopConfirm = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var use_default_1 = require("../_util/use-default");
var config_context_1 = require("../_util/config-context");
var outsideclick_1 = require("../util/outsideclick");
var mediaobject_1 = require("../mediaobject");
var bubble_1 = require("../bubble");
function PopConfirmClickTrigger(_a) {
    var childrenElementRef = _a.childrenElementRef, overlayElementRef = _a.overlayElementRef, visible = _a.visible, setVisible = _a.setVisible, _b = _a.openDelay, openDelay = _b === void 0 ? 0 : _b, _c = _a.closeDelay, closeDelay = _c === void 0 ? 0 : _c, render = _a.render;
    var _d = (0, outsideclick_1.useOutsideClick)([
        childrenElementRef,
        overlayElementRef,
    ]), listen = _d.listen, ignoreProps = _d.ignoreProps;
    listen(function () {
        if (visible) {
            setVisible(false, closeDelay);
        }
    });
    return render({
        overlayProps: ignoreProps,
        childrenProps: {
            onClick: function () { return setVisible(!visible, openDelay); },
        },
    });
}
PopConfirmClickTrigger.displayName = 'PopConfirmClickTrigger';
function PopConfirm(_a) {
    var title = _a.title, message = _a.message, children = _a.children, footer = _a.footer, className = _a.className, _visible = _a.visible, _onVisibleChange = _a.onVisibleChange, props = (0, tslib_1.__rest)(_a, ["title", "message", "children", "footer", "className", "visible", "onVisibleChange"]);
    var classPrefix = (0, config_context_1.useConfig)().classPrefix;
    var _b = (0, tslib_1.__read)((0, use_default_1.useDefault)(_visible, false, _onVisibleChange), 2), visible = _b[0], onVisibleChange = _b[1];
    var close = function () { return onVisibleChange(false); };
    return (react_1.default.createElement(bubble_1.Bubble, (0, tslib_1.__assign)({}, props, { visible: visible, onVisibleChange: onVisibleChange, className: (0, classnames_1.default)(classPrefix + "-popconfirm", className), trigger: PopConfirmClickTrigger, content: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: classPrefix + "-popconfirm__body" },
                react_1.default.createElement(mediaobject_1.MediaObject, null,
                    title && (react_1.default.createElement("h3", { className: classPrefix + "-popconfirm__messagetitle" }, title)),
                    message && (react_1.default.createElement("div", { className: classPrefix + "-popconfirm__messagetext" }, message)))),
            footer && (react_1.default.createElement("div", { className: classPrefix + "-popconfirm__footer" }, typeof footer === 'function' ? footer.call(null, close) : footer))) }), children));
}
exports.PopConfirm = PopConfirm;
PopConfirm.displayName = 'PopConfirm';
